'use client';

import { TBlogCategoryItemized } from '@/app/(blogposts)/blog/blog.types';
import { Button } from '@/components/ui/Button';
import clsx from 'clsx';
import Link from 'next/link';
import { redirect } from 'next/navigation';
import { useCallback, useState } from 'react';

import './BlogHeaderMoreTopicsItem.scss';

type Props = {
  className?: string;
  content: TBlogCategoryItemized[];
};

const MoreTopicsArrow: React.FC<{ className?: string; color?: string }> = ({
  className,
  color,
}) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={clsx(`MoreTopicsArrow`, className)}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.3541 5.54294C12.4006 5.58939 12.4376 5.64456 12.4628 5.70531C12.488 5.76606 12.501 5.83118 12.501 5.89694C12.501 5.96271 12.488 6.02783 12.4628 6.08858C12.4376 6.14932 12.4006 6.2045 12.3541 6.25094L8.00008 10.6039L3.64608 6.25094C3.5522 6.15706 3.49945 6.02972 3.49945 5.89694C3.49945 5.76417 3.5522 5.63683 3.64608 5.54294C3.73997 5.44906 3.86731 5.39631 4.00008 5.39631C4.13286 5.39631 4.2602 5.44906 4.35408 5.54294L8.00008 9.18994L11.6461 5.54294C11.6925 5.49638 11.7477 5.45944 11.8085 5.43423C11.8692 5.40902 11.9343 5.39605 12.0001 5.39605C12.0659 5.39605 12.131 5.40902 12.1917 5.43423C12.2525 5.45944 12.3076 5.49638 12.3541 5.54294Z'
      fill={color ? color : '#292722'}
    />
  </svg>
);

export const BlogHeaderMoreTopicsItem: React.FC<Props> = ({
  className,
  content,
}) => {
  const [isHovered, setHovered] = useState(false);

  const handleClick = useCallback(
    (categorySlug: string) => redirect(`/blog/category/${categorySlug}`),
    []
  );

  return (
    <div
      className={clsx(
        'BlogHeaderMoreTopicsItem flex-column flex items-center',
        className
      )}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
    >
      <button
        className={clsx('BlogHeaderMoreTopicsItem__button', {
          'BlogHeaderMoreTopicsItem__button--hovered': isHovered,
        })}
      >
        <p> Topics</p>

        <MoreTopicsArrow
          className={clsx(`BlogHeaderMoreTopicsItem__arrow`, {
            'BlogHeaderMoreTopicsItem__arrow--reversed': isHovered,
          })}
          color={isHovered ? '#986f34' : undefined}
        />
      </button>

      {isHovered && (
        <div className='BlogHeaderMoreTopicsItem__menu whitespace-no-wrap grid gap-2 px-6 py-5'>
          <Button
            className='BlogHeaderMoreTopicsItem__menu-button'
            variant='ghost'
          >
            <Link href='/blog'>All topics</Link>
          </Button>

          {content.map(({ item }, index) => (
            <Button
              className='BlogHeaderMoreTopicsItem__menu-button'
              key={`${item.id}//${index}`}
              onClick={() => handleClick(item.categorySlug)}
              variant='ghost'
            >
              {item.title}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
